<template>
    <Popup :open="open" @open="this.$emit('update:open', (open = !open))" popupWidth="w-3/4 md:w-3/4 lg:w-1/3" :padding="true">
        <Loading :loading="loading" class="min-h-full">
            <div v-if="!loading">
                <div class="py-4 border-b border-gray-300 w-full">
                    <strong>
                        {{ $t('subscription_add_video_analysis') }}
                    </strong>
                </div>
                <div class="mt-4">
                    <div class="flex flex-row gap-4 items-center justify-between py-4">
                        <div class="w-[50px] h-[50px] text-white shrink-0">
                            <img :alt="$translate(getWebinar.name)" class="w-full h-full object-contain" :src="abonnement.product.image.replace('.png', '-gradient.png')" />
                        </div>
                        <div class="w-9/12">
                            <strong class="text-sm line-clamp-1 text-ellipsis overflow-hidden">
                                {{ $translate(getWebinar.name) }}
                            </strong>
                            <p>
                                {{ $t('once_price', { price: $toCurrency(webinarVariant?.total_end_price_gross) }) }}
                            </p>
                            <p>
                                {{ $t('afterwards_price', { price: $toCurrency(webinarVariant?.base_price_gross) }) }}
                            </p>
                            <p>
                                {{ $t('runtime', { runtime: $translate(getAbonnementPeriod.title) }) }}
                            </p>
                            <p class="mt-2 text-blue text-xs">
                                {{ $t('webinar_duration_depends_on_written_subscription') }}
                            </p>
                        </div>
                    </div>

                    <hr class="w-full border-gray-300 border-b-0.5 my-4" />

                    <FormButton
                        @click="buyWebinar()"
                        class="mt-3 py-4"
                        styling="primary flex items-center gap-3 w-full justify-center"
                        :value="$t('buy_video_analysis')"
                        :disabled="false"
                    >
                    </FormButton>
                </div>
            </div>
        </Loading>
    </Popup>
</template>

<script>
import { mapGetters } from 'vuex';
import Toastification from '../miscellaneous/Toastification.vue';
import _ from 'lodash';

export default {
    data: () => ({
        webinarVariant: null,
        loading: true
    }),

    mounted() {
        this.loading = true;

        // get the product Group for the current Abonnement
        this.$store.dispatch('product_group/show', this.abonnement.product.productGroups.data[0].id).then(() => {
            // get the corresponding Webinar to the Abonnement
            this.webinar = this.getWebinar;
            this.webinarVariant = this.getWebinarVariantByPeriod(this.getAbonnementPeriod.meta.runtime_in_days);
            this.loading = false;
        });
    },

    props: ['open', 'abonnement'],
    emits: ['update:open', 'update:abonnement'],

    watch: {
        open: function () {
            this.$emit('update:open', this.open);
        }
    },
    computed: {
        getAbonnementPeriod() {
            return this.abonnement.productVariant.productAttributeValues.data.find((productAttributeValue) => productAttributeValue.meta.type === 'period');
        },
        getAbonnementFrequency() {
            return this.abonnement.productVariant.productAttributeValues.data.find((productAttributeValue) => productAttributeValue.meta.type === 'frequency');
        },
        ...mapGetters('user', ['isLoggedIn', 'receivesNewsletters', 'hasCustomer']),
        ...mapGetters('product_group', {
            getProductGroup: 'get',
            getProduct: 'getProduct',
            getWebinar: 'getWebinar',
            getWebinarVariantByPeriod: 'getWebinarVariantByPeriod',
            getProductAttributesByType: 'getProductAttributesByType'
        })
    },
    methods: {
        async buyWebinar() {
            this.loading = true;

            // reload the abonnements in parent component
            this.$parent.indexAbonnements();

            this.$store
                .dispatch('cart_products/store', {
                    product_variant_id: this.webinarVariant.id
                })
                .then((response) => {
                    // if no message in response the product was added succesfully
                    if (response?.meta?.message) {
                        _.forEach(response?.meta?.message, (message, type) => {
                            this.$toast[type === 'danger' ? 'error' : type]({
                                component: Toastification,
                                props: {
                                    message: message,
                                    type: type === 'danger' ? 'error' : type
                                }
                            });
                        });
                    }

                    this.$router.push({
                        name: 'checkout',
                        params: {
                            payment_method_id: this.abonnement.userPaymentMethod.id
                        }
                    });
                });
        }
    }
};
</script>
